import { Button } from '@crazyegginc/hatch';

import { useAuthContext, usePermissions, useMetric, useManageSubscriptionPath } from '/src/hooks';
import { Paywall } from '/src/components/Paywall';
import { FEATURES } from '/src/features/_global/constants';

import SurveysPNG from '@crazyegginc/hatch/dist/images/illustration-survey.png';
import SurveysWebP from '@crazyegginc/hatch/dist/images/illustration-survey.webp';
import { ReactComponent as TickIcon } from '@crazyegginc/hatch/dist/images/icon-tick-circle-filled.svg';
import { ReactComponent as ArrowIcon } from '@crazyegginc/hatch/dist/images/icon-arrow-expand.svg';
import { AppLink } from '/src/features/_global/components/AppLink';

export function SurveysUpgradePaywall({ mini }) {
  const { currentAccount } = useAuthContext();
  const trackMetric = useMetric();
  const subscriptionPath = useManageSubscriptionPath();

  const permissions = usePermissions();
  const canManageBilling = permissions.can('edit', FEATURES.BILLING).allowed;
  const isStripeUser = Boolean(currentAccount?.useStripe);

  return (
    <Paywall>
      <Paywall.Image
        webp={SurveysWebP}
        fallback={SurveysPNG}
        width={mini ? '80px' : '175px'}
        className={mini ? '!mb-3 !mt-2' : ''}
      />
      <Paywall.Title mini={mini}>Targeted feedback with Surveys</Paywall.Title>

      <Paywall.Body>
        Connect with your customers and website visitors to learn what makes them tick, what they want more of, and how
        they feel about your service.
        {mini ? null : (
          <div className="mt-6 flex justify-center">
            <div className="space-y-2">
              <div className="flex items-center">
                <TickIcon className="mr-2.5 h-4 w-4 fill-current text-lima-500" />
                Get direct feedback from the people that matter with Surveys.
              </div>
              <div className="flex items-center">
                <TickIcon className="mr-2.5 h-4 w-4 fill-current text-lima-500" />
                Customizable designs with in-built accessibility standards.
              </div>
              <div className="flex items-center">
                <TickIcon className="mr-2.5 h-4 w-4 fill-current text-lima-500" />
                Learn what your visitors think, instantly.
              </div>
            </div>
          </div>
        )}
        {!canManageBilling ? (
          <p className="mt-5">
            To get access to this feature, contact your Account Owner &#40;{currentAccount.ownerEmail}&#41; to upgrade
            the plan.
          </p>
        ) : null}
      </Paywall.Body>

      {canManageBilling ? (
        <Button
          component={AppLink}
          to={subscriptionPath}
          onMouseDown={() => trackMetric('upgrade_cta_click', 'surveys_upsell_paywall')}
          className="mb-5"
          target={isStripeUser ? '_blank' : '_self'}
          rel={isStripeUser ? 'noopener noreferrer' : undefined}
        >
          Get Surveys
          <ArrowIcon className="ml-2.5 h-2.5 w-2.5 rotate-90 fill-current" />
        </Button>
      ) : (
        <Button component="a" href={`mailto:${currentAccount.ownerEmail}`} className="mb-5">
          Contact account owner
        </Button>
      )}
    </Paywall>
  );
}
